/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
import { iterator as Symbol_iterator } from '../symbol/iterator';
export function isIterable(input) {
    return input && typeof input[Symbol_iterator] === 'function';
}
//# sourceMappingURL=isIterable.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isIterable.js
// module id = 2807
// module chunks = 2